export let MeetingLinkProvider = /*#__PURE__*/function (MeetingLinkProvider) {
  MeetingLinkProvider["NO_MEETING_LINK"] = "NO_MEETING_LINK";
  MeetingLinkProvider["GOOGLE"] = "GOOGLE";
  MeetingLinkProvider["MICROSOFT"] = "MICROSOFT";
  return MeetingLinkProvider;
}({});
//# sourceMappingURL=MeetingLinkProvider.js.map